import { render, staticRenderFns } from "./TheForgotPassword.vue?vue&type=template&id=2a93ed04&"
import script from "./TheForgotPassword.vue?vue&type=script&lang=js&"
export * from "./TheForgotPassword.vue?vue&type=script&lang=js&"
import style0 from "./TheForgotPassword.vue?vue&type=style&index=0&id=2a93ed04&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports